export default __webpack_public_path__ + "static/media/Time.1a8ff7a8.png";